import store from '@/store/app';

/**
 * Exposes `hasProviderAccessRights(...)` to Options API templates and component scripts.
 * The logic lives in the `auth/hasProviderAccessRights` Vuex getter;
 * Composition API code should use `useAccessRights()` from `@/composables/useAccessRights`.
 */
export default function registerHasProviderAccessRights(app) {
  app.config.globalProperties.hasProviderAccessRights = (levelTypes) =>
    store.getters['auth/hasProviderAccessRights'](levelTypes);
}
